import { isEnum } from 'types/fde/types'
import { RolodexEntryJson } from 'types/rolodex/rolodexEntries'
import { parseArray, parseDate, parseString } from 'utils/parsingHelpers'

import { GeckoEntryBase } from './geckoEntry'

export enum VisualInspectionType {
  EXTERNAL = 'external',
  INTERNAL = 'internal',
}

const isVisualInspectionType =
  isEnum<VisualInspectionType>(VisualInspectionType)

export class GeckoVisualInspection extends GeckoEntryBase<
  {
    name: string | undefined
    inspection_type: VisualInspectionType
    date: Date
    vendor?: string
    status?: string
    components?: string[]
    findings_summary?: string
  },
  {
    organization: string
    site: string
    unit: string
  }
> {
  private constructor(json: RolodexEntryJson) {
    const safeInspectionType: VisualInspectionType | undefined =
      isVisualInspectionType(json.data.inspection_type)
        ? json.data.inspection_type
        : undefined

    const safeDate = parseDate(json.data.date)

    if (!safeInspectionType) {
      throw new Error(
        `Unknown inspection_type for visual inspection "${json.id}": "${json.data.inspection_type}"`
      )
    }

    if (!safeDate) {
      throw new Error(
        `Unknown date for visual inspection "${json.id}": "${json.data.date}"`
      )
    }

    super(
      json,
      {
        name: parseString(json.data.name),
        inspection_type: safeInspectionType,
        date: safeDate,
        vendor: parseString(json.data.vendor) ?? '',
        status: parseString(json.data.status) ?? '',
        components: parseArray(json.data.components) ?? [],
        findings_summary: parseString(json.data.findings_summary) ?? '',
      },
      {
        organization: parseString(json.tags.organization) ?? '',
        site: parseString(json.tags.site) ?? '',
        unit: parseString(json.tags.unit) ?? '',
      },
      {}
    )
  }

  static CreateFromJSON(json: RolodexEntryJson): GeckoVisualInspection {
    return new GeckoVisualInspection(json)
  }
}
